import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { CreditCard, Landmark, FileDown, ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../api';
import { useLang } from '../context/LanguageContext';
import { useCurrency } from '../context/CurrencyContext';

export const PayButton = ({ kind, bookingId, amountInr, disabled }) => {
  const { t } = useLang();
  const { rates } = useCurrency();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const kwd = ((amountInr || 0) * (rates.KWD || 0.0037)).toFixed(3);

  const pay = async (method) => {
    setBusy(method);
    try {
      const res = await api.post('/payments/create', { kind, booking_id: bookingId, method });
      window.location.assign(res.data.payment_url);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not start payment');
      setBusy(null);
    }
  };

  return (
    <>
      <Button data-testid={`pay-btn-${bookingId}`} size="sm" disabled={disabled} onClick={() => setOpen(true)} className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white">
        <CreditCard className="w-4 h-4 mr-1" /> {t('payNow')}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="payment-dialog">
          <DialogHeader><DialogTitle>{t('payWith')} MyFatoorah</DialogTitle></DialogHeader>
          <p className="text-sm text-gray-500">Amount due: <span className="font-bold text-gray-900" data-testid="payment-amount-kwd">KD {kwd}</span> <span className="text-xs">(₹{Number(amountInr || 0).toLocaleString()})</span></p>
          <div className="grid grid-cols-2 gap-3 mt-2">
            <button data-testid="pay-knet-btn" disabled={!!busy} onClick={() => pay('knet')} className="rounded-xl border-2 border-gray-200 hover:border-teal-500 p-4 text-left transition-colors disabled:opacity-60">
              <Landmark className="w-6 h-6 text-teal-600 mb-2" /><p className="font-semibold">{t('knet')}</p><p className="text-xs text-gray-500">Kuwait debit cards</p>
            </button>
            <button data-testid="pay-card-btn" disabled={!!busy} onClick={() => pay('card')} className="rounded-xl border-2 border-gray-200 hover:border-teal-500 p-4 text-left transition-colors disabled:opacity-60">
              <CreditCard className="w-6 h-6 text-teal-600 mb-2" /><p className="font-semibold">{t('card')}</p><p className="text-xs text-gray-500">Visa / Mastercard</p>
            </button>
          </div>
          <p className="text-xs text-gray-400 flex items-center mt-2"><ShieldCheck className="w-3 h-3 mr-1" />{busy ? 'Redirecting to secure checkout…' : 'You will be redirected to MyFatoorah secure checkout.'}</p>
        </DialogContent>
      </Dialog>
    </>
  );
};

export const VoucherButton = ({ kind, bookingId }) => {
  const { t } = useLang();
  const href = `${process.env.REACT_APP_BACKEND_URL}/api/vouchers/${kind}/${bookingId}.pdf`;
  return (
    <a data-testid={`voucher-btn-${bookingId}`} href={href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center h-9 px-3 rounded-md border-2 border-teal-500 text-teal-600 text-sm font-medium hover:bg-teal-50 transition-colors">
      <FileDown className="w-4 h-4 mr-1" /> {t('voucher')}
    </a>
  );
};
